import {Plan, School, SchoolClass, User} from "models"
import {ShapeComponent, shapeComponent} from "set-state-compare/build/shape-component"
import Card from "components/chalky-layout/card"
import {digg} from "diggerize"
import isEven from "shared/is-even"
import memo from "set-state-compare/build/memo"
import PageContentsPresentation from "components/page-contents/presentation"
import PeriodOption from "./period-option"
import PropTypes from "prop-types"
import propTypesExact from "prop-types-exact"
import React from "react"
import {View} from "react-native"
import {WithDefaultStyle} from "@kaspernj/api-maker/build/utils/default-style"

/**
 * @typedef {object} ComponentsPlansSignUpModalStep2Props
 * @property {boolean} hidePriceTable
 * @property {unknown} onBackPressed
 * @property {unknown} onPeriodChosen
 * @property {unknown} plan
 * @property {unknown} resource
 */

/**
 * @typedef {object} ComponentsPlansSignUpModalStep2State
 * @property {unknown} selectedPeriod
 * @property {unknown} selectedPrice
 */

/**
 * @extends {ShapeComponent<ComponentsPlansSignUpModalStep2Props, ComponentsPlansSignUpModalStep2State>}
 */
class ComponentsPlansSignUpModalStep2 extends ShapeComponent {
  /** @type {ComponentsPlansSignUpModalStep2State} */
  state = {
    selectedPeriod: undefined,
    selectedPrice: undefined
  }

  static propTypes = propTypesExact({
    hidePriceTable: PropTypes.bool.isRequired,
    onBackPressed: PropTypes.func.isRequired,
    onPeriodChosen: PropTypes.func.isRequired,
    plan: PropTypes.instanceOf(Plan).isRequired,
    resource: PropTypes.oneOfType([PropTypes.instanceOf(School), PropTypes.instanceOf(SchoolClass), PropTypes.instanceOf(User)])
  })

  setup() {
    const {plan, resource} = this.p
    const resourceModelName = digg(resource.constructor.modelName(), "data", "modelClassData", "className")


    this.pageContentsLiquidVariables = React.useMemo(() => ({plan, resource}), [plan, resource])
    this.planResource = React.useMemo(() => this.p.plan.resources().loaded().find((resource) => resource.resourceName() == resourceModelName), [])
    this.monthlyPeriod = React.useMemo(() => this.tt.planResource?.periods()?.loaded()?.find((period) => period.months() == 1), [this.tt.planResource])
  }

  render() {
    const {hidePriceTable} = this.p
    const {monthlyPeriod, planResource} = this.tt
    const pageContentIdentifier = hidePriceTable ? "plans/sign-up-modal/step-2/sweden-hidden-prices" : "plans/sign-up-modal/step-2/header"
    const defaultStyle = React.useMemo(() => ({
      Text: {
        color: "#2c2c96"
      }
    }), [])

    return (
      <WithDefaultStyle style={defaultStyle}>
        <Card
          onClose={this.tt.onClosePress}
          testID="plans/sign-up-modal/step2"
          veryLarge
        >
          <View style={this.headerContainerStyle ||= {flex: 1, marginBottom: 20}}>
            <PageContentsPresentation
              identifier={pageContentIdentifier}
              liquidVariables={this.tt.pageContentsLiquidVariables}
            />
          </View>
          {!hidePriceTable &&
            <View
              style={this.periodOptionsContainerStyle ||= {flexDirection: "row", alignItems: "center"}}
              testID="plans/sign-up-modal/step2/period-options"
            >
              {planResource?.periods()?.loaded()?.sort((period1, period2) => period1.months() - period2.months())?.map((period, periodIndex) =>
                <View
                  key={period.id()}
                  style={this.cache(`periodOptionStyle${isEven(periodIndex) ? "Even" : "Odd"}`, {
                    marginRight: isEven(periodIndex) ? 10 : 0,
                    marginLeft: !isEven(periodIndex) ? 10 : 0,
                    marginBottom: 10
                  }, [])}
                >
                  <PeriodOption
                    monthlyPeriod={monthlyPeriod}
                    onSelect={this.tt.onPeriodSelect}
                    period={period}
                    selected={this.s.selectedPeriod?.id() == period.id()}
                  />
                </View>
              )}
            </View>
          }
        </Card>
      </WithDefaultStyle>
    )
  }

  onClosePress = () => {
    this.p.onBackPressed()
  }

  onPeriodSelect = ({period, price}) => {
    this.p.onPeriodChosen({period, price})
  }
}

export default memo(shapeComponent(ComponentsPlansSignUpModalStep2))
